import React, { Fragment, useEffect, useState } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { Paper, DialogActions, Button, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
}
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650
  },
  progress: {
    position: "absolute",
    top: "60px",
    right: "20px"
  },
  modalPaper: {
    width: "10%"
  },

  withoutLabel: {
    marginTop: theme.spacing(3)
  },
  formHeader: {
    backgroundColor: "#002060",
    color: "white"
  },
  formFooter: {
    backgroundColor: "gainsboro",
    padding: "10px"
  }
}));

function AddTag(props) {
  const { article, tags, setArticleNewTag, updateTags } = props;

  const [newTags, setNewTags] = useState(null);
  const [iniTags, setIniTags] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    if (article && tags && tags.length) {
      setIniTags(!article.tags ? [] : article.tags.map((t) => ({ id: t.tag.id, tag: t.tag.tag })));
    }
  }, [article, tags, newTags]);

  const handleClose = () => {
    setArticleNewTag(null);
  };

  useEffect(() => {}, [tags]);

  const onChange = (val) => {
    setNewTags(val);
  };
  const handleSave = (article) => {
    console.log("Say whaaat?");
    if (newTags) {
      console.log(newTags);
      updateTags(article, newTags);
      setNewTags(null);
    } /*else {
      updateTags(article, iniTags);
    }*/
    handleClose();
  };
  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth={true}
      style={{ left: "20px" }}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={article || false}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      {article && tags && tags.length > 0 && (
        <Paper style={{ padding: "10px" }}>
          <Autocomplete
            id="tag-select-popup"
            style={{ width: "100%" }}
            options={tags}
            disableClearable={false}
            clearOnBlur={true}
            classes={{
              option: classes.option
            }}
            multiple
            autoSelect
            defaultValue={iniTags}
            size="small"
            onChange={(e, newVal) => onChange(newVal)}
            getOptionLabel={(option) => option.tag}
            renderOption={(option) => <React.Fragment>{option.tag}</React.Fragment>}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tags"
                variant="outlined"
                autoFocus
                margin="dense"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "off" // disable autocomplete and autofill
                }}
              />
            )}
          />
        </Paper>
      )}
      <DialogActions>
        {" "}
        <Button onClick={handleClose} variant="contained" color="secondary">
          CLOSE
        </Button>{" "}
        <Button onClick={(e) => handleSave(article)} variant="contained" color="primary">
          SAVE
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddTag;
